import React from 'react';
import { size } from 'lodash';
import Icon403 from '../images/403.svg';
import { Flex } from './Flex';
import { Paragraph, Title } from './Text';
import { useSelector } from 'react-redux';

const Page403 = () => {
    const { grants } = useSelector(state => state.user);

    return (
        <Flex height="100%" align="center" justify="center">
            <Flex flex="0 0 80%" direction="column" style={{ textAlign: "center" }}>
                <img src={Icon403} alt="403" style={{ maxHeight: "278px", marginBottom: "22px" }} />
                <Title h3 color="#3E6FC1" margin={{ bottom: "10px" }} >Sorry, but you do not have enough permissions to view this page</Title>
                <Paragraph size="16px">Your access permissions do not allow you to access the contents of the page.</Paragraph>
                <Paragraph size="16px">Please contact your administrator or <a href="mailto: spsupport@vmssoftware.com">VSI Support</a> to request access{size(grants) ? <>, or return to <a href='/'>Main Page</a></> : ""}.</Paragraph>
            </Flex>
        </Flex>
    )
}

export { Page403 };